<template>
  <div class="machine-information">
    <div class="machine-information__content">
      <oie-my-machine-images :images="machine.images"></oie-my-machine-images>
      <div>
        <dl class="machine-information__vehicle">
          <div>
            <dt>{{ tStatic('machineType') }}</dt>
            <dd>{{ vehicleIdDictionary[machine.type] }}</dd>
          </div>
          <div>
            <dt>{{ tStatic('machineManufacturer') }}</dt>
            <dd>{{ vehicleIdDictionary[machine.manufacturer] }}</dd>
          </div>
          <div>
            <dt>{{ tStatic('machineModel') }}</dt>
            <dd>{{ vehicleIdDictionary[machine.model] }}</dd>
          </div>
        </dl>
        <oie-info-wrapper>
          <oie-info-wrapper-item>
            <p>{{ tStatic('machineBelongsToOwner') }}</p>
            <p>{{ machine.machineOwnerId ? machineOwnerDictionary[machine.machineOwnerId] : tStatic('noMachineOwnerSelected') }}</p>
          </oie-info-wrapper-item>
          <oie-info-wrapper-item>
            <p>{{ tStatic('otherInfo') }}</p>
            <p>{{ machine.info ? machine.info : tStatic('machineInfoNothingSpecified') }}</p>
          </oie-info-wrapper-item>
        </oie-info-wrapper>
        <div class="machine-information__advanced-fields">
          <button
            v-tooltip.top="tStatic('advancedFieldsDetailPageTooltip')"
            type="button"
            class="machine-information__advanced-fields-toggler"
            @click="showAdvancedFields = !showAdvancedFields">
            <h2 class="machine-information__sub-title">
              {{ tStatic('advancedFields') }}
            </h2>
            <oie-base-icon icon="chevron-down"></oie-base-icon>
          </button>

          <div v-if="showAdvancedFields" class="machine-information__section-content">
            <!-- SECTION ADVANCED FIELDS -->
            <oie-info-wrapper>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineSerialNumber') }}</p>
                <p>{{ machine.serialNumber ? machine.serialNumber : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineYearModel') }}</p>
                <p>{{ machine.yearModel ? machine.yearModel : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineMotorType') }}</p>
                <p>{{ machine.motorType ? machine.motorType : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineMotorNumber') }}</p>
                <p>{{ machine.motorNumber ? machine.motorNumber : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineCabinNumber') }}</p>
                <p>{{ machine.cabinNumber ? machine.cabinNumber : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineFrontAxleNumber') }}</p>
                <p>{{ machine.frontAxleNumber ? machine.frontAxleNumber : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineRearAxleNumber') }}</p>
                <p>{{ machine.rearAxleNumber ? machine.rearAxleNumber : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>
              <oie-info-wrapper-item>
                <p>{{ tStatic('machineGearboxType') }}</p>
                <p>{{ machine.gearboxType ? machine.gearboxType : tStatic('machineInfoNothingSpecified') }}</p>
              </oie-info-wrapper-item>

              <h2 class="machine-information__sub-title">
                {{ tStatic('customFieldsTitle') }}
              </h2>
              <template v-if="hasCustomFields">
                <div v-for="(val, key) in machine.customFields" :key="`custom-field-${key}`">
                  <oie-info-wrapper-item>
                    <p>{{ metaDataMachineFields[key] }}</p>
                    <p>{{ machine.customFields[key] }}</p><p>
                    </p>
                  </oie-info-wrapper-item>
                </div>
              </template>
              <template v-else>
                {{ tStatic('machineInfoNothingSpecified') }}
              </template>
            </oie-info-wrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    machine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showAdvancedFields: false
    }
  },
  computed: {
    ...mapGetters('myMachines', ['vehicleIdDictionary', 'machineOwnerDictionary', 'metaDataMachineFields']),
    hasCustomFields() { return !_.isEmpty(this.machine.customFields) }

  }

}
</script>

<style lang="scss">

.machine-information {
  container-type: inline-size;
  position: relative;
}

.machine-information__content {
  display: grid;

  grid-template-columns: 1fr;
  gap: measure(half);

  @container (min-width: 900px) {
    grid-template-columns: 1fr 2fr;
  }
}

.machine-information__vehicle {
  @include body-smaller;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid color(gray-4);
  padding-bottom: measure(half);
  margin-bottom: measure(half);

  @include media('to-small') {
    grid-template-columns: 1fr;
  }
}

.machine-information__vehicle dt {
  @include body-smaller-bold;
}

.machine-information__sub-title {
  @include h3-semi-bold;
}

.machine-information__section-content >* {
  margin-bottom: measure(full);
}

.machine-information__advanced-fields {
  border-top: 1px solid color(border-gray);
  border-bottom: 1px solid color(border-gray);
  margin-bottom: measure(full);
}

.machine-information__advanced-fields-toggler {
  @include reset-button;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: measure(half) 0;
}
</style>
